<div id="dietCalendarModal" #dietCalendarModal class="modal" tabindex="-1">
  <div class="d-flex justify-content-center align-items-center">
    <div class="modal-dialog modal-fullscreen" style="width: 70%">
      <div class="modal-content">
        <div class="modal-header">
          <h2 *ngIf="modalShow == 'calendar'">Calendario de dieta</h2>
          <h2 *ngIf="modalShow == 'diet' && selectedDate">
            <i
              class="bi bi-arrow-left"
              (click)="handleBackButtonClick()"
              style="cursor: pointer; margin-right: 10px"
            ></i>
            Detalle de dieta - {{ selectedDate | date : "dd/MM/yyyy" }}
          </h2>

          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="p-4" *ngIf="modalShow == 'calendar'">
            <full-calendar
              #calendar
              [options]="calendarOptions"
              class="w-100 h-100 z-3"
            ></full-calendar>
          </div>

          <div
            class="p-4"
            *ngIf="modalShow == 'diet'"
            (ngIfChange)="onModalShowChange('diet')"
          >
            <app-meal-detail [date]="selectedDate"></app-meal-detail>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
